import { GridHeaderCellProps } from '@progress/kendo-react-grid';
import { GridColumn } from 'src/components/GridWrapper';
import { validateNumber } from './VarianceLineItemColumns';

const headerCell = (props: GridHeaderCellProps) => <div className="text-center">{props.title}</div>;

export const varianceGLCodesColumns: GridColumn<any>[] = [
  {
    field: 'glCdDescription',
    title: 'GL Code',
    filter: 'text',
    dataType: 'string',
    minResizableWidth: 100,
  },
  {
    field: 'acctPeriod',
    title: 'Accounting Period',
    filter: 'text',
    dataType: 'string',
    minResizableWidth: 90,
  },
  {
    title: 'Tax',
    headerCell,
    menu: false,
    childrenColumn: [
      {
        field: 'poTaxes',
        title: 'PO Amt',
        filter: 'numeric',
        dataType: 'dollar',
        format: '{0:c2}',
        filterFormat: 'c2',
        minResizableWidth: 90,
      },
      {
        field: 'invoicedTaxes',
        title: 'Inv Amt',
        filter: 'numeric',
        dataType: 'dollar',
        format: '{0:c2}',
        filterFormat: 'c2',
        minResizableWidth: 90,
      },
      {
        field: 'taxVariance',
        title: 'Variance',
        filter: 'numeric',
        dataType: 'dollar',
        format: '{0:c2}',
        specificStyle: validateNumber,
        filterFormat: 'c2',
        minResizableWidth: 90,
      },
    ],
  },
  {
    title: 'Shipping',
    headerCell,
    field: '',
    menu: false,
    childrenColumn: [
      {
        field: 'poShipping',
        title: 'PO Amt',
        filter: 'numeric',
        dataType: 'dollar',
        format: '{0:c2}',
        filterFormat: 'c2',
        minResizableWidth: 90,
      },
      {
        field: 'invoicedShipping',
        title: 'Inv Amt',
        filter: 'numeric',
        dataType: 'dollar',
        format: '{0:c2}',
        filterFormat: 'c2',
        minResizableWidth: 90,
      },
      {
        field: 'shippingVariance',
        title: 'Variance',
        filter: 'numeric',
        dataType: 'dollar',
        format: '{0:c2}',
        specificStyle: validateNumber,
        filterFormat: 'c2',
        minResizableWidth: 90,
      },
    ],
  },
  {
    title: 'Discount',
    headerCell,
    menu: false,
    childrenColumn: [
      {
        field: 'poDiscount',
        title: 'PO Amt',
        filter: 'numeric',
        dataType: 'dollar',
        format: '{0:c2}',
        filterFormat: 'c2',
        minResizableWidth: 90,
      },
      {
        field: 'invoicedDiscount',
        title: 'Inv Amt',
        filter: 'numeric',
        dataType: 'dollar',
        format: '{0:c2}',
        filterFormat: 'c2',
        minResizableWidth: 90,
      },
      {
        field: 'discountVariance',
        title: 'Variance',
        filter: 'numeric',
        dataType: 'dollar',
        format: '{0:c2}',
        specificStyle: validateNumber,
        filterFormat: 'c2',
        minResizableWidth: 90,
      },
    ],
  },
  {
    field: 'totalVariance',
    title: 'Total Variance',
    filter: 'numeric',
    dataType: 'dollar',
    format: '{0:c2}',
    specificStyle: validateNumber,
    filterFormat: 'c2',
    minResizableWidth: 90,
  },
];
